<bb-content-back-drop></bb-content-back-drop>
<section fxLayout="column" fxLayoutAlign="center center">
  <div>
    <h2>Thank you!</h2>

    <p>You have successfully submitted your loan inquiry form.
      Someone from Balikbayad will be in touch with you within
      one business day.</p>

    <button mat-raised-button color="primary" routerLink="/faq">You're Welcome!</button>
  </div>
</section>
